import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  DISCUSSION_FILTER_TYPE,
  discussionTypeList,
  IMessagingHeaderFilters,
} from '../../constants/messages.constants';
import { AppState } from '../../../store/app-state';
import {
  discardMessagingGroupCache,
  filterMessages,
  loadFirstPageOfGroups,
  setMessagingView,
} from '../../../store/messages/messages.actions';
import { IMessagingGroup, MESSAGING_VIEWS } from '../../../store/messages/messages.interfaces';
import { getMessagingView, getSelectedGroup } from '../../../store/messages/messages.selectors';
import { BackButtonBoxComponent } from '../../back-button-box/back-button-box.component';
import { DropdownComponent } from '@app/framework/inputs/dropdown/dropdown.component';
import { SearchInputComponent } from '@app/framework/search-input/search-input.component';
import { SimpleButtonComponent } from '@app/framework/buttons/simple-medium-button/simple-button.component';

@Component({
  selector: 'app-messages-header',
  templateUrl: './messages-header.component.html',
  styleUrls: ['./messages-header.component.scss'],
  imports: [
    BackButtonBoxComponent,
    AsyncPipe,
    DropdownComponent,
    FormsModule,
    SearchInputComponent,
    SimpleButtonComponent,
  ],
})
export class MessagesHeaderComponent implements OnInit, OnDestroy {
  defaultDiscussionType: DISCUSSION_FILTER_TYPE = DISCUSSION_FILTER_TYPE.ALL_DISCUSSIONS;
  discussionTypeList: { type: DISCUSSION_FILTER_TYPE; text: string }[] = discussionTypeList;
  MESSAGING_VIEWS = MESSAGING_VIEWS;
  selectedView$ = this.store.select(getMessagingView);
  selectedGroup$: Observable<IMessagingGroup> = this.store.select(getSelectedGroup);
  defaultHeaderFilter = { search: undefined, discussionType: undefined };
  filter: IMessagingHeaderFilters = this.defaultHeaderFilter;
  isDestroyed$ = new Subject<void>();
  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.selectedView$.pipe(takeUntil(this.isDestroyed$)).subscribe(() => {
      this.filter = { ...this.defaultHeaderFilter };
    });
  }

  openCreateDiscussion() {
    this.store.dispatch(setMessagingView({ view: MESSAGING_VIEWS.DISCUSSION_CREATE }));
  }

  goBack(view = MESSAGING_VIEWS.DISCUSSION_LIST) {
    this.store.dispatch(setMessagingView({ view }));
    if (view === MESSAGING_VIEWS.DISCUSSION_LIST) {
      this.store.dispatch(loadFirstPageOfGroups({}));
    }

    if (view !== MESSAGING_VIEWS.DISCUSSION_VIEW) {
      this.store.dispatch(discardMessagingGroupCache());
    }
  }

  onTypeFilterChange(newType: DISCUSSION_FILTER_TYPE) {
    this.filter.discussionType = newType;
    this.store.dispatch(filterMessages({ filters: { ...this.filter } }));
  }

  onTextFilterChange(text) {
    this.filter.search = text;
    this.store.dispatch(filterMessages({ filters: { ...this.filter } }));
  }

  ngOnDestroy() {
    this.isDestroyed$.next();
    this.isDestroyed$.complete();
  }
}
